import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, List, ListItem, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  root: {
    height: "inherit"
  },
  bottom: {
    padding: theme.spacing(0, 1, 1, 1),
    borderTop: "2px solid " + theme.palette.divider
  },
  messages: {
    padding: theme.spacing(0, 0, 1, 0),
    maxHeight: "calc(100% - 150px)",
    overflowY: "auto"
  },
  button: {
    //textPrimary: 'white'
    color: "white"
  },

  messageGrid: {},

  message: {
    wordBreak: "break-all"
  },

  bold: {
    fontWeight: "500"
  }
}));

export default function Chatroom({ messages, sendMessage, status }) {
  const classes = useStyles();

  const [message, setMessage] = useState("");

  function submit() {
    sendMessage(message);
    setMessage("");
  }

  function keyPress(e) {
    if (e.keyCode == 13) {
      submit();
    }
  }

  return (
    <Grid
      container
      direction="column"
      justify="flex-end"
      className={classes.root}
    >
      <Grid item className={classes.messages}>
        <Grid container direction="column" className={classes.messageGrid}>
          {messages &&
            messages.map((message, index) => (
              <ListItem key={index}>
                <Typography className={classes.message}>
                  <span className={classes.bold}>{message.user.name}</span>
                  {(message.user.name !== "" ? ": " : "") + message.message}
                </Typography>
              </ListItem>
            ))}
        </Grid>
      </Grid>

      <Grid item className={classes.bottom}>
        <TextField
          id="outlined-name"
          label="Message"
          value={message}
          onChange={e => setMessage(e.target.value)}
          margin="normal"
          variant="outlined"
          rows={2}
          multiline
          fullWidth
          onKeyDown={keyPress}
        />

        <Button
          color="primary"
          variant="outlined"
          className={classes.button}
          onClick={submit}
        >
          Send
        </Button>
      </Grid>
    </Grid>
  );
}
